<template>  
    <div>
        <b-table
            hover
            responsive
            select-mode="single"
            small
            :selectable="true"
            :ref="id" 
            :id="id"          
            :primary-key="primaryKey"
            :items="items"
            :fields="fields"            
            :tbody-tr-class="rowClass"
            @row-clicked="onRowSelected"
            :sticky-header="size"
            style="min-height: 130px;margin-top: 10px;"            
            no-border-collapse
            stacked="sm">

            <template v-slot:cell(actions)="row">
                <div>
                    <b-button size="sm" v-show="(onRegistraPagamento !== null) && (row.item['VALOR_UTILIZAR'] != 0)" variant="success" class="mb-0" id="btn_edit" @click="onRegistraPagamento(row.item)" style="margin-right: 5px;">
                        <b-icon icon="cash-stack" aria-hidden="true"></b-icon>&nbsp;Novo
                    </b-button>
                    <b-button size="sm" v-show="(onShowDetail !== null) && (row.item['VALOR_DEPOSITO'] > 0)" variant="info" class="mb-0" id="btn_detail" @click="onShowDetail(row.item)" style="margin-right: 5px;">
                        <b-icon icon="eye" aria-hidden="true"></b-icon>&nbsp;Pagamentos
                    </b-button>
                    <b-button size="sm" v-show="onBaixarComprovante !== null" variant="info" class="mb-0" id="btn_detail" @click="onBaixarComprovante(row.item)" style="margin-right: 5px;">
                        <b-icon icon="file-earmark-arrow-down" aria-hidden="true"></b-icon>&nbsp;Baixar
                    </b-button>
                </div>
            </template>        
        </b-table>        
    </div>
</template>

<script>

import _ from 'lodash';

export default {
    name: 'PagamentoTable',
    
    props: {
        id: String,
        primaryKey: String,
        items: Array,
        fields: Array,
        onRegistraPagamento: {
            type: Function,
            default: null,
        },
        rowClass: Function,
        onShowDetail: {
            type: Function,
            default: null,
        },
        returnFocus: {
            type: String,
            default: "",
            require: false
        },
        onLoadMore: {
            type: Function,
            default: null,
        },
        size:{
            type: String,
            default: '500px',
        },
        onBaixarComprovante: {
            type: Function,
            default: null,
        },
    },

    data() {
        return {
            selected: [], 
            debouncedScroll: false,           
        };
    },

    updated: function(){
        this.totalRows = this.items.length
    },
    mounted() {
        this.debouncedScroll = _.debounce(this.onScroll, 200);
        if(this.onLoadMore != null){
            this.$nextTick(() => {
                const scrollEl = this.$refs[this.id]?.$el;
                if (scrollEl) {
                    scrollEl.addEventListener('scroll', this.onScroll);
                }
            });
        }
    },
    beforeDestroy() {
        if(this.onLoadMore != null){
            const scrollEl = this.$refs[this.id]?.$el;
            if (scrollEl) {
                scrollEl.removeEventListener('scroll', this.onScroll);
            }
        }
    },
    methods: {
        onScroll: _.debounce(function (e) {
            const target = e.target;
            const scrollBottom = target.scrollTop + target.clientHeight;
            const scrollHeight = target.scrollHeight;

            if (scrollBottom >= scrollHeight - 5) {
                this.onLoadMore();
            }
        }, 200),
        percorrerLista(event) {
            if (event.key === 'ArrowDown') {
                const firstRow = this.$refs[this.id].$el.querySelector('tbody tr:first-child');
                firstRow.focus();
            }
        },
        onRowSelected(item) {  
            if (this.onRegistraPagamento != null)
                this.onRegistraPagamento(item);            
        },
        openDetail(item) {            
            this.onShowDetail(item[0]);
        },
        onCancel() {
            this.$bvModal.hide('delete_register_'+ this.id);   
        },
        
    },    
}
</script>

<style>
    .b-table-sticky-header thead th {
        position: sticky !important; /* Garante que o cabeçalho permaneça fixo */
        top: 0!important;
        z-index: 12!important; /* Mantém o cabeçalho acima do conteúdo */
        background-color: #f8f9fa!important; /* Define cor de fundo fixa */
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1)!important; /* Adiciona uma sombra para destacar */ 
        padding-top: 0px!important;
    }
    
    .b-table-sortable-column {
        position: relative;
        z-index: 12; /* Garante que a funcionalidade sortable fique acima */
    }
</style>